import { getBrandId } from '../helpers/getBrandId/getBrandId';

export enum QueryKeys {
  item = 'item',
  blob = 'blob',
  itemModifierGroups = 'itemModifierGroups',
  items = 'items',
  productSizes = 'productSizes',
  optionGroups = 'optionGroups',
  menu = 'menu',
  menus = 'menus',
  inventory = 'inventory',
  inventoryItem = 'inventoryItem',
  ranges = 'ranges',
  menuLabels = 'menuLabels',
  librarySyncStatus = 'librarySyncStatus',
  venueSyncStatus = 'venueSyncStatus',
  notifications = 'notifications',
  statusPageSummary = 'statusPageSummary',
  productPrices = 'productPrices',
  venues = 'venues',
  venueCategories = 'venueCategories',
  priceBands = 'priceBands',
  priceRules = 'priceRules',
  priceSchemes = 'priceSchemes',
  externalSystems = 'externalSystems',
  events = 'events',
  publishPlan = 'publishPlan',
  pricingCategories = 'pricingCategories',
  schedules = 'schedules',
  publishHistory = 'publishHistory',
  validationReport = 'validationReport',
  timetables = 'timetables',
  timetable = 'timetable',
  menuSets = 'menuSets',
  menuSet = 'menuSet',
  ingestDiff = 'ingestDiff',
  recordIdentifierSchema = 'recordIdentifierSchema',
  recordIdentifiers = 'recordIdentifiers',
}

export const SYNC_STATUS_QUERY = [getBrandId(), QueryKeys.librarySyncStatus];
export const VENUE_SYNC_STATUS_QUERY = [getBrandId(), QueryKeys.venueSyncStatus];
export const NOTIFICATIONS_QUERY = [getBrandId(), QueryKeys.notifications];
export const PRICE_RULES_QUERY = [getBrandId(), QueryKeys.priceRules];

export const getIngestDiffQueryKey = (eventId?: string) => [getBrandId(), QueryKeys.ingestDiff, eventId];
